import $ from "./jquery-global.js";
import "iframe-resizer/js/iframeResizer.js";

const coreUtils = (() => { // eslint-disable-line

  const me = {};

  me.init = (selector, component) => {

    if ($(selector).length && component && component.init && typeof component.init === 'function') {

      component.init();

    }

  };

  me.initVideo = ($element) => {

    if (!$element.length) {
      return;
    }

    // no autoplay in creo - load video directly
    // $(element).on('click', function() {

    const $playButton = $element.siblings();
    const $videoContainer = $element.parent();
    const youtubeId = $element.parent().data().youtubeid;

    $playButton.addClass('hidden');
    $element.addClass('hidden');

    if (youtubeId) {

      $videoContainer.prepend('<iframe src="https://player.cvm3.se/' + youtubeId + '?fetch=true" frameborder="0" title="Youtube" allowfullscreen></iframe>');

    }

    // });

  };

  // Inject SVG spritesheet to top of DOM with ajax (SVG spritesheet generated by Gulp)
  me.loadSVGSpritesheet = (filePath, className) => {

    const ajax = new XMLHttpRequest();
    ajax.open('GET', filePath, true);
    ajax.send();

    ajax.onload = function () {

      const div = document.createElement('div');
      div.classList.add(className);
      div.style.display = 'none';
      div.innerHTML = ajax.responseText;
      document.body.insertBefore(div, document.body.childNodes[0]);

    };

  };

  me.equalHeights = (element) => {

    $(element).css('height', '');

    $.fn.setAllToMaxHeight = function () { // eslint-disable-line

      return this.height(Math.max.apply(this, $.map(this, function (e) { return $(e).height() }))); // eslint-disable-line

    };

    $(element).setAllToMaxHeight();
    $(element).addClass('has-equal-height');

  };

  me.equalWidths = (element) => {

    $(element).css('width', '');

    $.fn.setAllToMaxWidth = function () { // eslint-disable-line

      return this.width(Math.max.apply(this, $.map(this, function (e) { return $(e).width() }))); // eslint-disable-line

    };

    $(element).setAllToMaxWidth();
    $(element).addClass('has-equal-width');

  };

  me.detectBrowser = () => {

    const ua = navigator.userAgent.toLowerCase();

    let browser;

    if (ua.indexOf('safari') !== -1) {

      if (ua.indexOf('chrome') > -1) {

        browser = 'chrome';

      } else {

        browser = 'safari';

      }

    }

    return browser;

  };

  me.addSpanToButtons = () => {

    $('.button, .button-regular').each(function () {

      if ($(this).find('span').length === 0) {

        const text = $(this).text();
        $(this).html(`<span> ${text} </span>`);

      }

    });

  };

  me.handleScrollOnBack = () => {

    // Check if session variable for scroll is set, and scroll to position
    if (sessionStorage.getItem('scrollposition-enabled') && sessionStorage.getItem('scrollposition-enabled') > 100) {

      $('html, body')
        .animate({

          scrollTop: sessionStorage.getItem('scrollposition-enabled'),

        }, {

          duration: 1000,
          easing: 'swing',

        });

      sessionStorage.setItem('scrollposition-enabled', 0);

    }

  };

  me.clickBack = () => {

    // if (document.referrer.indexOf(location.host) > -1) {

    //   const lang = document.documentElement.lang;

    //   if (sessionStorage.getItem('lang') && lang !== sessionStorage.getItem('lang') && ($('.back').attr('data-url') == null || $('.back').attr('data-url').length == 0)) {

    //     $('.back').hide();

    //   }

    //   $('.back').on('click', function(e) {

    //     if (sessionStorage.getItem('scrollposition')) {

    //       const scroll = sessionStorage.getItem('scrollposition');

    //       sessionStorage.setItem('scrollposition-enabled', scroll);

    //     }

    //     if (sessionStorage.getItem('lang') && lang == sessionStorage.getItem('lang')) {

    //       e.preventDefault();
    //       window.history.go(-1);

    //     }

    //   });

    // } else if (($('.back') != null && $('.back').attr('data-url') == null) || $('.back').attr('data-url').length == 0) {

    //   $('.back').hide();

    // }

  };

  me.setBackButtonUrl = () => {

    // me.handleScrollOnBack();

    // if ($(''.back) && !$('.back').attr('href')) {

    //   $('.back').attr('href', '/');

    // }

    // $('a:not(.back):not(.accordion-title):not(.tabs-link)').on('click', (e) => {

    //   let scroll = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
    //   sessionStorage.setItem('scrollposition', scroll);
    //   sessionStorage.setItem('lang', document.documentElement.lang);
    //   sessionStorage.setItem('scrollposition-enabled', 0);

    // });

    // me.clickBack();

  };

  me.iFrameHeight = () => {
    $('.api-iframe').on('load', function () {
      $(this).iFrameResize();
    });
  };

  me.autoScroll = (element, animationDuration) => {

    let thisElement;

    if (typeof element !== 'number') {

      thisElement = parseInt(element.position().top, 10);

    } else {

      thisElement = element;

    }

    $('html, body')
      .animate({
        scrollTop: thisElement,
      }, {
        duration: animationDuration,
        easing: 'swing',
      });

  };

  me.wordBreaker = () => {

    const $word = $('.js-wbr');
    const breaker = '&shy;';
    let newText;

    $word.each(function () {

      newText = breaker + $(this).html();

      $(this).replaceWith(newText);

    });

  };

  me.scrollToId = (delay = 1500, ease = 'swing', excludeLinksQuery, callback) => {

    // Always starts at the top of the page
    if (window.location.hash) {
      scroll(0, 0);
    }

    // prevent flickering
    setTimeout(() => {
      scroll(0, 0);
    }, 1);

    $(() => {
      const urlHash = window.location.hash;
      const hashLinks = $(`a[href*="#"]${excludeLinksQuery}`);

      // Normal link behavior
      hashLinks.on('click', function (e) {
        let linkValue = $(this).attr('href');
        const UrlPathName = window.location.pathname;

        // Remove current page path name if
        // it exists in href value
        if (linkValue.indexOf(UrlPathName) >= 0) {
          linkValue = linkValue.replace(UrlPathName, '');
        }

        if (linkValue !== undefined && linkValue.length > 1
          && linkValue.indexOf('panel-') !== 1 && $(linkValue) !== undefined) {
          callback = callback.bind(this);
          callback(e, linkValue);
        }
      });

      // Looks for an anchor inside the url
      if (urlHash) {
        var element = $(urlHash);
        if (element.length) {
          $('html, body').animate({
            scrollTop: `${element.offset().top}px`,
          }, delay, ease);
        }
      }
    });
  };

  // Modernizr and autoplay detection
  me.detectAutoplaySupport = function () {

    /*!
      * modernizr v3.3.1
     * Build https://modernizr.com/download?-videoautoplay-setclasses-dontmin
     *
     * Copyright (c)
     *  Faruk Ates
     *  Paul Irish
     *  Alex Sexton
     *  Ryan Seddon
     *  Patrick Kettner
     *  Stu Cox
     *  Richard Herrera

     * MIT License
     */

    /*
     * Modernizr tests which native CSS3 and HTML5 features are available in the
     * current UA and makes the results available to you in two ways: as properties on
     * a global `Modernizr` object, and as classes on the `<html>` element. This
     * information allows you to progressively enhance your pages with a granular level
     * of control over the experience.
    */

    (function (window, document, undefined) {
      const classes = [];

      const tests = [];

      /**
       *
       * ModernizrProto is the constructor for Modernizr
       *
       * @class
       * @access public
       */

      const ModernizrProto = {
        // The current version, dummy
        _version: '3.3.1',

        // Any settings that don't work as separate modules
        // can go in here as configuration.
        _config: {
          classPrefix: '',
          enableClasses: true,
          enableJSClass: true,
          usePrefixes: true,
        },

        // Queue of tests
        _q: [],

        // Stub these for people who are listening
        on(test, cb) {
          // I don't really think people should do this, but we can
          // safe guard it a bit.
          // -- NOTE:: this gets WAY overridden in src/addTest for actual async tests.
          // This is in case people listen to synchronous tests. I would leave it out,
          // but the code to *disallow* sync tests in the real version of this
          // function is actually larger than this.
          const self = this;
          setTimeout(() => {
            cb(self[test]);
          }, 0);
        },

        addTest(name, fn, options) {
          tests.push({ name, fn, options });
        },

        addAsyncTest(fn) {
          tests.push({ name: null, fn });
        },
      };

      // Fake some of Object.create so we can force non test results to be non "own" properties.
      let Modernizr = function () { };
      Modernizr.prototype = ModernizrProto;

      // Leak modernizr globally when you `require` it rather than force it here.
      // Overwrite name so constructor name is nicer :D
      Modernizr = new Modernizr();

      /**
       * is returns a boolean if the typeof an obj is exactly type.
       *
       * @access private
       * @function is
       * @param {*} obj - A thing we want to check the type of
       * @param {string} type - A string to compare the typeof against
       * @returns {boolean}
       */

      function is(obj, type) {
        return typeof obj === type;
      }

      /**
       * Run through all tests and detect their support in the current UA.
       *
       * @access private
       */

      function testRunner() {
        let featureNames;
        let feature;
        let aliasIdx;
        let result;
        let nameIdx;
        let featureName;
        let featureNameSplit;

        for (const featureIdx in tests) {
          if (tests.hasOwnProperty(featureIdx)) {
            featureNames = [];
            feature = tests[featureIdx];
            // run the test, throw the return value into the Modernizr,
            // then based on that boolean, define an appropriate className
            // and push it into an array of classes we'll join later.
            //
            // If there is no name, it's an 'async' test that is run,
            // but not directly added to the object. That should
            // be done with a post-run addTest call.
            if (feature.name) {
              featureNames.push(feature.name.toLowerCase());

              if (feature.options && feature.options.aliases && feature.options.aliases.length) {
                // Add all the aliases into the names list
                for (aliasIdx = 0; aliasIdx < feature.options.aliases.length; aliasIdx++) {
                  featureNames.push(feature.options.aliases[aliasIdx].toLowerCase());
                }
              }
            }

            // Run the test, or use the raw value if it's not a function
            result = is(feature.fn, 'function') ? feature.fn() : feature.fn;

            // Set each of the names on the Modernizr object
            for (nameIdx = 0; nameIdx < featureNames.length; nameIdx++) {
              featureName = featureNames[nameIdx];
              // Support dot properties as sub tests. We don't do checking to make sure
              // that the implied parent tests have been added. You must call them in
              // order (either in the test, or make the parent test a dependency).
              //
              // Cap it to TWO to make the logic simple and because who needs that kind of subtesting
              // hashtag famous last words
              featureNameSplit = featureName.split('.');

              if (featureNameSplit.length === 1) {
                Modernizr[featureNameSplit[0]] = result;
              } else {
                // cast to a Boolean, if not one already
                /* jshint -W053 */
                if (Modernizr[featureNameSplit[0]] && !(Modernizr[featureNameSplit[0]] instanceof Boolean)) {
                  Modernizr[featureNameSplit[0]] = new Boolean(Modernizr[featureNameSplit[0]]);
                }

                Modernizr[featureNameSplit[0]][featureNameSplit[1]] = result;
              }

              classes.push((result ? '' : 'no-') + featureNameSplit.join('-'));
            }
          }
        }
      }

      /**
       * docElement is a convenience wrapper to grab the root element of the document
       *
       * @access private
       * @returns {HTMLElement|SVGElement} The root element of the document
       */

      const docElement = document.documentElement;

      /**
       * A convenience helper to check if the document we are running in is an SVG document
       *
       * @access private
       * @returns {boolean}
       */

      const isSVG = docElement.nodeName.toLowerCase() === 'svg';

      /**
       * setClasses takes an array of class names and adds them to the root element
       *
       * @access private
       * @function setClasses
       * @param {string[]} classes - Array of class names
       */

      // Pass in an and array of class names, e.g.:
      //  ['no-webp', 'borderradius', ...]
      function setClasses(classes) {
        let { className } = docElement;
        const classPrefix = Modernizr._config.classPrefix || '';

        if (isSVG) {
          className = className.baseVal;
        }

        // Change `no-js` to `js` (independently of the `enableClasses` option)
        // Handle classPrefix on this too
        if (Modernizr._config.enableJSClass) {
          const reJS = new RegExp('(^|\\s)' + classPrefix + 'no-js(\\s|$)');
          className = className.replace(reJS, '$1' + classPrefix + 'js$2');
        }

        if (Modernizr._config.enableClasses) {
          // Add the new classes
          className += ' ' + classPrefix + classes.join(' ' + classPrefix);
          isSVG ? docElement.className.baseVal = className : docElement.className = className;
        }

      }

      /**
       * createElement is a convenience wrapper around document.createElement. Since we
       * use createElement all over the place, this allows for (slightly) smaller code
       * as well as abstracting away issues with creating elements in contexts other than
       * HTML documents (e.g. SVG documents).
       *
       * @access private
       * @function createElement
       * @returns {HTMLElement|SVGElement} An HTML or SVG element
       */

      function createElement() {
        if (typeof document.createElement !== 'function') {
          // This is the case in IE7, where the type of createElement is "object".
          // For this reason, we cannot call apply() as Object is not a Function.
          return document.createElement(arguments[0]);
        } if (isSVG) {
          return document.createElementNS.call(document, 'http://www.w3.org/2000/svg', arguments[0]);
        }
        return document.createElement.apply(document, arguments);

      }

      /*!
    {
      "name": "HTML5 Video",
      "property": "video",
      "caniuse": "video",
      "tags": ["html5"],
      "knownBugs": [
        "Without QuickTime, `Modernizr.video.h264` will be `undefined`; https://github.com/Modernizr/Modernizr/issues/546"
      ],
      "polyfills": [
        "html5media",
        "mediaelementjs",
        "sublimevideo",
        "videojs",
        "leanbackplayer",
        "videoforeverybody"
      ]
    }
    ! */
      /* DOC
    Detects support for the video element, as well as testing what types of content it supports.

    Subproperties are provided to describe support for `ogg`, `h264` and `webm` formats, e.g.:

    ```javascript
    Modernizr.video         // true
    Modernizr.video.ogg     // 'probably'
    ```
    */

      // Codec values from : github.com/NielsLeenheer/html5test/blob/9106a8/index.html#L845
      //                     thx to NielsLeenheer and zcorpan

      // Note: in some older browsers, "no" was a return value instead of empty string.
      //   It was live in FF3.5.0 and 3.5.1, but fixed in 3.5.2
      //   It was also live in Safari 4.0.0 - 4.0.4, but fixed in 4.0.5

      Modernizr.addTest('video', () => {
        /* jshint -W053 */
        const elem = createElement('video');
        let bool = false;

        // IE9 Running on Windows Server SKU can cause an exception to be thrown, bug #224
        try {
          if (bool = !!elem.canPlayType) {
            bool = new Boolean(bool);
            bool.ogg = elem.canPlayType('video/ogg; codecs="theora"').replace(/^no$/, '');

            // Without QuickTime, this value will be `undefined`. github.com/Modernizr/Modernizr/issues/546
            bool.h264 = elem.canPlayType('video/mp4; codecs="avc1.42E01E"').replace(/^no$/, '');

            bool.webm = elem.canPlayType('video/webm; codecs="vp8, vorbis"').replace(/^no$/, '');

            bool.vp9 = elem.canPlayType('video/webm; codecs="vp9"').replace(/^no$/, '');

            bool.hls = elem.canPlayType('application/x-mpegURL; codecs="avc1.42E01E"').replace(/^no$/, '');
          }
        } catch (e) { }

        return bool;
      });

      /**
       * hasOwnProp is a shim for hasOwnProperty that is needed for Safari 2.0 support
       *
       * @author kangax
       * @access private
       * @function hasOwnProp
       * @param {object} object - The object to check for a property
       * @param {string} property - The property to check for
       * @returns {boolean}
       */

      // hasOwnProperty shim by kangax needed for Safari 2.0 support
      let hasOwnProp;

      (function () {
        const _hasOwnProperty = ({}).hasOwnProperty;
        /* istanbul ignore else */
        /* we have no way of testing IE 5.5 or safari 2,
         * so just assume the else gets hit */
        if (!is(_hasOwnProperty, 'undefined') && !is(_hasOwnProperty.call, 'undefined')) {
          hasOwnProp = function (object, property) {
            return _hasOwnProperty.call(object, property);
          };
        } else {
          hasOwnProp = function (object, property) { /* yes, this can give false positives/negatives, but most of the time we don't care about those */
            return ((property in object) && is(object.constructor.prototype[property], 'undefined'));
          };
        }
      }());

      // _l tracks listeners for async tests, as well as tests that execute after the initial run
      ModernizrProto._l = {};

      /**
       * Modernizr.on is a way to listen for the completion of async tests. Being
       * asynchronous, they may not finish before your scripts run. As a result you
       * will get a possibly false negative `undefined` value.
       *
       * @memberof Modernizr
       * @name Modernizr.on
       * @access public
       * @function on
       * @param {string} feature - String name of the feature detect
       * @param {function} cb - Callback function returning a Boolean - true if feature is supported, false if not
       * @example
       *
       * ```js
       * Modernizr.on('flash', function( result ) {
       *   if (result) {
       *    // the browser has flash
       *   } else {
       *     // the browser does not have flash
       *   }
       * });
       * ```
       */

      ModernizrProto.on = function (feature, cb) {
        // Create the list of listeners if it doesn't exist
        if (!this._l[feature]) {
          this._l[feature] = [];
        }

        // Push this test on to the listener list
        this._l[feature].push(cb);

        // If it's already been resolved, trigger it on next tick
        if (Modernizr.hasOwnProperty(feature)) {
          // Next Tick
          setTimeout(() => {
            Modernizr._trigger(feature, Modernizr[feature]);
          }, 0);
        }
      };

      /**
       * _trigger is the private function used to signal test completion and run any
       * callbacks registered through [Modernizr.on](#modernizr-on)
       *
       * @memberof Modernizr
       * @name Modernizr._trigger
       * @access private
       * @function _trigger
       * @param {string} feature - string name of the feature detect
       * @param {function|boolean} [res] - A feature detection function, or the boolean =
       * result of a feature detection function
       */

      ModernizrProto._trigger = function (feature, res) {
        if (!this._l[feature]) {
          return;
        }

        const cbs = this._l[feature];

        // Force async
        setTimeout(() => {
          let i; let
            cb;
          for (i = 0; i < cbs.length; i++) {
            cb = cbs[i];
            cb(res);
          }
        }, 0);

        // Don't trigger these again
        delete this._l[feature];
      };

      /**
       * addTest allows you to define your own feature detects that are not currently
       * included in Modernizr (under the covers it's the exact same code Modernizr
       * uses for its own [feature detections](https://github.com/Modernizr/Modernizr/tree/master/feature-detects)). Just like the offical detects, the result
       * will be added onto the Modernizr object, as well as an appropriate className set on
       * the html element when configured to do so
       *
       * @memberof Modernizr
       * @name Modernizr.addTest
       * @optionName Modernizr.addTest()
       * @optionProp addTest
       * @access public
       * @function addTest
       * @param {string|object} feature - The string name of the feature detect, or an
       * object of feature detect names and test
       * @param {function|boolean} test - Function returning true if feature is supported,
       * false if not. Otherwise a boolean representing the results of a feature detection
       * @example
       *
       * The most common way of creating your own feature detects is by calling
       * `Modernizr.addTest` with a string (preferably just lowercase, without any
       * punctuation), and a function you want executed that will return a boolean result
       *
       * ```js
       * Modernizr.addTest('itsTuesday', function() {
       *  var d = new Date();
       *  return d.getDay() === 2;
       * });
       * ```
       *
       * When the above is run, it will set Modernizr.itstuesday to `true` when it is tuesday,
       * and to `false` every other day of the week. One thing to notice is that the names of
       * feature detect functions are always lowercased when added to the Modernizr object. That
       * means that `Modernizr.itsTuesday` will not exist, but `Modernizr.itstuesday` will.
       *
       *
       *  Since we only look at the returned value from any feature detection function,
       *  you do not need to actually use a function. For simple detections, just passing
       *  in a statement that will return a boolean value works just fine.
       *
       * ```js
       * Modernizr.addTest('hasJquery', 'jQuery' in window);
       * ```
       *
       * Just like before, when the above runs `Modernizr.hasjquery` will be true if
       * jQuery has been included on the page. Not using a function saves a small amount
       * of overhead for the browser, as well as making your code much more readable.
       *
       * Finally, you also have the ability to pass in an object of feature names and
       * their tests. This is handy if you want to add multiple detections in one go.
       * The keys should always be a string, and the value can be either a boolean or
       * function that returns a boolean.
       *
       * ```js
       * var detects = {
       *  'hasjquery': 'jQuery' in window,
       *  'itstuesday': function() {
       *    var d = new Date();
       *    return d.getDay() === 2;
       *  }
       * }
       *
       * Modernizr.addTest(detects);
       * ```
       *
       * There is really no difference between the first methods and this one, it is
       * just a convenience to let you write more readable code.
       */

      function addTest(feature, test) {

        if (typeof feature === 'object') {
          for (const key in feature) {
            if (hasOwnProp(feature, key)) {
              addTest(key, feature[key]);
            }
          }
        } else {

          feature = feature.toLowerCase();
          const featureNameSplit = feature.split('.');
          let last = Modernizr[featureNameSplit[0]];

          // Again, we don't check for parent test existence. Get that right, though.
          if (featureNameSplit.length == 2) {
            last = last[featureNameSplit[1]];
          }

          if (typeof last !== 'undefined') {
            // we're going to quit if you're trying to overwrite an existing test
            // if we were to allow it, we'd do this:
            //   var re = new RegExp("\\b(no-)?" + feature + "\\b");
            //   docElement.className = docElement.className.replace( re, '' );
            // but, no rly, stuff 'em.
            return Modernizr;
          }

          test = typeof test === 'function' ? test() : test;

          // Set the value (this is the magic, right here).
          if (featureNameSplit.length == 1) {
            Modernizr[featureNameSplit[0]] = test;
          } else {
            // cast to a Boolean, if not one already
            /* jshint -W053 */
            if (Modernizr[featureNameSplit[0]] && !(Modernizr[featureNameSplit[0]] instanceof Boolean)) {
              Modernizr[featureNameSplit[0]] = new Boolean(Modernizr[featureNameSplit[0]]);
            }

            Modernizr[featureNameSplit[0]][featureNameSplit[1]] = test;
          }

          // Set a single class (either `feature` or `no-feature`)
          /* jshint -W041 */
          setClasses([(!!test && test != false ? '' : 'no-') + featureNameSplit.join('-')]);
          /* jshint +W041 */

          // Trigger the event
          Modernizr._trigger(feature, test);
        }

        return Modernizr; // allow chaining.
      }

      // After all the tests are run, add self to the Modernizr prototype
      Modernizr._q.push(() => {
        ModernizrProto.addTest = addTest;
      });

      /*!
    {
      "name": "Video Autoplay",
      "property": "videoautoplay",
      "tags": ["video"],
      "async" : true,
      "warnings": ["This test is very large – only include it if you absolutely need it"],
      "knownBugs": ["crashes with an alert on iOS7 when added to homescreen"]
    }
    ! */
      /* DOC
    Checks for support of the autoplay attribute of the video element.
    */

      Modernizr.addAsyncTest(() => {
        let timeout;
        const waitTime = 200;
        const retries = 5;
        let currentTry = 0;
        const elem = createElement('video');
        const elemStyle = elem.style;

        function testAutoplay(arg) {
          currentTry++;
          clearTimeout(timeout);

          const result = arg && arg.type === 'playing' || elem.currentTime !== 0;

          if (!result && currentTry < retries) {
            // Detection can be flaky if the browser is slow, so lets retry in a little bit
            timeout = setTimeout(testAutoplay, waitTime);
            return;
          }

          elem.removeEventListener('playing', testAutoplay, false);
          addTest('videoautoplay', result);
          elem.parentNode.removeChild(elem);
        }

        // skip the test if video itself, or the autoplay
        // element on it isn't supported
        if (!Modernizr.video || !('autoplay' in elem)) {
          addTest('videoautoplay', false);
          return;
        }

        elemStyle.position = 'absolute';
        elemStyle.height = 0;
        elemStyle.width = 0;

        try {
          if (Modernizr.video.ogg) {
            elem.src = 'data:video/ogg;base64,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';
          } else if (Modernizr.video.h264) {
            elem.src = 'data:video/mp4;base64,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';
          } else {
            addTest('videoautoplay', false);
            return;
          }
        } catch (e) {
          addTest('videoautoplay', false);
          return;
        }

        elem.setAttribute('autoplay', '');
        elem.style.cssText = 'display:none';
        docElement.appendChild(elem);
        // wait for the next tick to add the listener, otherwise the element may
        // not have time to play in high load situations (e.g. the test suite)
        setTimeout(() => {
          elem.addEventListener('playing', testAutoplay, false);
          timeout = setTimeout(testAutoplay, waitTime);
        }, 0);
      });

      // Run each test
      testRunner();

      // Remove the "no-js" class if it exists
      setClasses(classes);

      delete ModernizrProto.addTest;
      delete ModernizrProto.addAsyncTest;

      // Run the things that are supposed to run after the tests
      for (let i = 0; i < Modernizr._q.length; i++) {
        Modernizr._q[i]();
      }

      // Leak Modernizr namespace
      window.Modernizr = Modernizr;

    }(window, document));
  };

  return me;

})(jQuery);

export default coreUtils;
